import { render, staticRenderFns } from "./HeaderPane.vue?vue&type=template&id=2a3bcfc8&scoped=true&"
import script from "./HeaderPane.vue?vue&type=script&lang=ts&"
export * from "./HeaderPane.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderPane.vue?vue&type=style&index=0&id=2a3bcfc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3bcfc8",
  null
  
)

export default component.exports